import React from 'react';

import { openComponentModal } from '@src/actions/BotActions';
import EntityEditor from '@src/containers/Entities/EntityEditor';

const getContextMenuOptionsModes = {
  VIEW: 'VIEW',
  TOGGLE: 'TOGGLE',
};

export const getSelectedText = () => {
  return window.getSelection().toString();
};

export const getSelectedPosition = () => {
  const selection = window.getSelection();
  const textRange = selection.getRangeAt(0); // get the text range
  return textRange.getBoundingClientRect();
};

export const getContextMenuOptions = (
  selectedText,
  userResponse,
  clickHandlers,
  domainTitle,
  showTagOptions
) => {
  const contextMenuOptions = [];
  const splitWords = selectedText.split(' ');
  const synonyms = getSynonymFlatList(userResponse.synonyms, domainTitle);
  const entities = getEntitiesFlatList(
    userResponse.nodeEntitiesDetailed,
    domainTitle
  );
  // TODO: clean all the tags logic, we will be deprecating this.
  if (showTagOptions) {
    contextMenuOptions.push(
      _getContextMenuOptionForTags(selectedText, userResponse, clickHandlers)
    );
  }
  if (splitWords.length > 1) {
    contextMenuOptions.push(
      _getContextMenuOptionForWord(
        selectedText,
        synonyms,
        entities,
        userResponse,
        clickHandlers,
        getContextMenuOptionsModes.VIEW
      )
    );
    contextMenuOptions.push(
      _getContextMenuOptionForWord(
        selectedText,
        synonyms,
        entities,
        userResponse,
        clickHandlers,
        getContextMenuOptionsModes.TOGGLE
      )
    );
  } else {
    splitWords.map((selectedWord) => {
      contextMenuOptions.push(
        _getContextMenuOptionForWord(
          selectedWord,
          synonyms,
          entities,
          userResponse,
          clickHandlers,
          getContextMenuOptionsModes.VIEW
        )
      );
      contextMenuOptions.push(
        _getContextMenuOptionForWord(
          selectedWord,
          synonyms,
          entities,
          userResponse,
          clickHandlers,
          getContextMenuOptionsModes.TOGGLE
        )
      );
    });
  }

  if (contextMenuOptions.length > 0) {
    // these options are filtered to remove null values which are added when the
    // word has no entities/synonyms options applicable.
    return contextMenuOptions.filter((option) => option != null);
  }
};

export const getContextMenuPosition = (
  selectedPosition,
  wrapperRect,
  showOnlyDisambiguation = false,
  isNewPipeline = false
) => {
  // These number are found by hit & trial
  // No logic
  let topDifference = 24;

  if (isNewPipeline) {
    // These number are found by hit & trial
    // No logic
    topDifference = !showOnlyDisambiguation ? 190 : 0;
  }
  return {
    top: selectedPosition.top - wrapperRect.top + topDifference,
    left: selectedPosition.left + selectedPosition.width / 2,
  };
};

export function getSynonymFlatList(synonyms, domainTitle) {
  const disabledSynonyms = [];
  const enabledSynonyms = [];
  const enabledSynonymsDetailed = [];
  const disabledSynonymsDetailed = [];

  Object.keys(synonyms).map((synonym) => {
    const cluster_name = synonym ? synonym.split('__')[1] : '';
    const variants = synonyms[synonym].variants || [];
    const synonymData = { ...synonyms[synonym], cluster_name: synonym };
    if (synonyms[synonym].active) {
      enabledSynonyms.push(cluster_name);
      enabledSynonymsDetailed.push(synonymData);
      variants.map((word) => {
        enabledSynonyms.push(word);
        enabledSynonymsDetailed.push(synonymData);
      });
    } else {
      disabledSynonyms.push(cluster_name);
      disabledSynonymsDetailed.push(synonymData);

      variants.map((word) => {
        disabledSynonyms.push(word);
        disabledSynonymsDetailed.push(synonymData);
      });
    }
  });

  return {
    enabledSynonyms,
    disabledSynonyms,
    enabledSynonymsDetailed,
    disabledSynonymsDetailed,
  };
}

export function getEntitiesFlatList(entities, domainTitle) {
  const disabledEntities = [];
  const enabledEntities = [];
  const enabledEntitiesDetailed = [];
  const disabledEntitiesDetailed = [];

  entities.map((entity) => {
    if (entity.active) {
      entity.words.map((word) => {
        enabledEntities.push(word);
        enabledEntitiesDetailed.push(entity);
      });
    } else {
      entity.words.map((word) => {
        disabledEntities.push(word);
        disabledEntitiesDetailed.push(entity);
      });
    }
  });

  return {
    disabledEntities,
    enabledEntities,
    enabledEntitiesDetailed,
    disabledEntitiesDetailed,
  };
}

export function sortResponsesFn(a, b) {
  if (a.active === b.active) return 0;
  if (a.active) return -1;
  if (b.active) return 1;
  if (a.title == '') return 1;
  if (b.title == '') return -1;
  return 0;
}

export function wereTagsToggled(editedData = [], id, tags, prevTags) {
  let toggled = false;
  editedData.map((userResponse) => {
    if (id == userResponse.id) {
      toggled = true;
    }
  });
  return toggled;
}

export function wereSynonymsToggled(text = '', updatedSynonyms) {
  let toggled = false;
  text.split(' ').map((word) => {
    if (_findIndexForWord(word, updatedSynonyms) > -1) toggled = true;
    return word;
  });
  return toggled;
}

export function wereEntitiesToggled(entities, updatedEntities) {
  if (Object.keys(entities).length !== Object.keys(updatedEntities).length)
    return true;

  let toggled = false;
  Object.keys(entities).map((entity) => {
    if (entities[entity].active !== updatedEntities[entity].active) {
      toggled = true;
    }
  });

  return toggled;
}

function _findIndexForWord(word, synonyms = []) {
  let index = -1;
  Object.keys(synonyms).map((synonym, i) => {
    if (
      (synonyms[synonym].variants &&
        synonyms[synonym].variants.indexOf(word) > -1) ||
      [].indexOf(word) > -1 ||
      (synonyms[synonym].cluster_name || '__|__').split('__')[1] === word
    ) {
      index = i;
    }
  });
  return index;
}

function _getContextMenuOptionForTags(
  selectedText,
  userResponse,
  clickHandlers
) {
  if (userResponse.tags.indexOf(selectedText) > -1) {
    return {
      text: 'Remove Tag',
      iconType: 'synonym_highlight',
      color: 'red',
      onClick: (e) => clickHandlers.removeTag(selectedText, userResponse),
    };
  }
  return {
    text: 'Add Tag',
    iconType: 'synonym_highlight',
    onClick: (e) => clickHandlers.addTag(selectedText, userResponse),
  };
}

function _getContextMenuOptionForWord(
  word,
  synonyms,
  entities,
  userResponse,
  clickHandlers,
  mode
) {
  if (!synonyms) return;
  const enabledSynonymsIndex = synonyms.enabledSynonyms
    .map((synonym) => synonym.toUpperCase())
    .indexOf(word.toUpperCase());
  const disabledSynonymsIndex = synonyms.disabledSynonyms
    .map((synonym) => synonym.toUpperCase())
    .indexOf(word.toUpperCase());

  const enabledEntitiesIndex = entities.enabledEntities
    .map((entity) => entity.toUpperCase())
    .indexOf(word.toUpperCase());

  const disabledEntitiesIndex = entities.disabledEntities
    .map((entity) => entity.toUpperCase())
    .indexOf(word.toUpperCase());

  const contextMenuSynonymOption = {
    text: `<strong>${word}</strong> View Synonyms`,
    iconType: 'synonym_duplicate',
    color: 'blue',
  };
  const contextMenuEntityOption = {
    text: `<strong>${word}</strong> View Entity`,
    iconType: 'synonym_duplicate',
    color: 'blue',
  };

  if (mode === 'VIEW') {
    if (enabledSynonymsIndex > -1) {
      // ENABLED
      contextMenuSynonymOption.onClick = (e) =>
        clickHandlers.viewSynonyms(
          synonyms.enabledSynonymsDetailed[enabledSynonymsIndex],
          userResponse,
          true
        );
      return contextMenuSynonymOption;
    }

    if (disabledSynonymsIndex > -1) {
      const synonym = synonyms.disabledSynonymsDetailed[disabledSynonymsIndex];
      contextMenuSynonymOption.color = 'black';
      contextMenuSynonymOption.onClick = (e) =>
        clickHandlers.viewSynonyms(
          synonyms.disabledSynonymsDetailed[disabledSynonymsIndex],
          userResponse,
          true
        );
      return contextMenuSynonymOption;
    }

    if (enabledEntitiesIndex > -1) {
      const entityName =
        entities?.enabledEntitiesDetailed?.[enabledEntitiesIndex]?.entity;
      const entityId =
        entities?.enabledEntitiesDetailed?.[enabledEntitiesIndex]?.id;
      contextMenuEntityOption.onClick = (e) =>
        openComponentModal(
          <EntityEditor entityName={entityName} entityId={entityId} />,
          entityName,
          null,
          'CROSS'
        );

      return contextMenuEntityOption;
    }

    if (disabledEntitiesIndex > -1) {
      const entityName =
        entities.disabledEntitiesDetailed[disabledEntitiesIndex].entity;
      const entityId =
        entities.disabledEntitiesDetailed[enabledEntitiesIndex].id;
      contextMenuEntityOption.onClick = (e) =>
        openComponentModal(
          <EntityEditor entityName={entityName} entityId={entityId} />,
          entityName,
          null,
          'CROSS'
        );

      return contextMenuEntityOption;
    }
  }

  if (mode === 'TOGGLE') {
    // for synonyms
    if (enabledSynonymsIndex > -1) {
      // ENABLED
      contextMenuSynonymOption.text = `<strong>${word}</strong> Disable Synonym`;
      contextMenuSynonymOption.onClick = (e) =>
        clickHandlers.toggleSynonyms(
          synonyms.enabledSynonymsDetailed[enabledSynonymsIndex],
          false
        );
      return contextMenuSynonymOption;
    }
    if (disabledSynonymsIndex > -1) {
      // ENABLED

      contextMenuSynonymOption.text = `<strong>${word}</strong> Enable Synonym`;
      contextMenuSynonymOption.onClick = (e) =>
        clickHandlers.toggleSynonyms(
          synonyms.disabledSynonymsDetailed[disabledSynonymsIndex],
          true
        );
      return contextMenuSynonymOption;
    }
    if (enabledEntitiesIndex > -1) {
      // ENABLED
      contextMenuEntityOption.text = `<strong>${word}</strong> Disable Entity`;
      contextMenuEntityOption.onClick = (e) =>
        clickHandlers.toggleEntities(
          entities.enabledEntitiesDetailed[enabledEntitiesIndex],
          false
        );
      return contextMenuEntityOption;
    }
    if (disabledEntitiesIndex > -1) {
      // ENABLED

      contextMenuEntityOption.text = `<strong>${word}</strong> Enable Entity`;
      contextMenuEntityOption.onClick = (e) =>
        clickHandlers.toggleEntities(
          entities.disabledEntitiesDetailed[disabledEntitiesIndex],
          true
        );
      return contextMenuEntityOption;
    }
  }

  return null;
}

function _insertTagAtWord(styledText, word, tag, className) {
  const regex = new RegExp(`\\b(${word})\\b`, 'gi');
  return styledText.replace(
    regex,
    (match) => `<${tag} class="${className}">${match}</${tag}>`
  );
}
